import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { fieldNotes, formatDate } from '@/data/fieldNotes';

const FieldNotesIndex: React.FC = () => {
  return (
    <div className="min-h-screen bg-maslow-cream">
      <Helmet>
        <title>Field Notes — Maslow</title>
        <link rel="canonical" href="https://maslow.nyc/field-notes" />
        <meta
          name="description"
          content="Writing on restroom culture, city infrastructure, human dignity, and the spaces between."
        />
        <meta property="og:title" content="Field Notes — Maslow" />
        <meta property="og:description" content="Writing on restroom culture, city infrastructure, human dignity, and the spaces between." />
      </Helmet>

      <div className="max-w-3xl mx-auto px-6 pt-14 pb-24">
        {/* Page Header */}
        <div className="mb-6">
          <p className="text-xs md:text-sm font-bold uppercase tracking-[0.2em] mb-3 text-maslow-gold">
            Field Notes
          </p>
          <h1 className="text-3xl md:text-4xl font-serif text-maslow-navy leading-tight">
            Writing on restroom culture, city infrastructure, and human dignity.
          </h1>
        </div>

        {/* Posts List — hairline rows, no cards */}
        <div>
          {fieldNotes.map((note) => (
            <Link key={note.slug} to={`/field-notes/${note.slug}`} className="block group">
              <article className="py-8 border-b border-[color-mix(in_srgb,var(--navy)_10%,transparent)]">
                <p className="text-xs uppercase tracking-[0.16em] text-[color-mix(in_srgb,var(--navy)_50%,transparent)] mb-2">
                  {formatDate(note.date)}
                  {note.tags.length > 0 && (
                    <span className="text-[color-mix(in_srgb,var(--navy)_40%,transparent)]">
                      {'  ·  '}
                      {note.tags.join(' · ')}
                    </span>
                  )}
                </p>
                <h2 className="text-2xl md:text-[28px] font-serif text-maslow-navy group-hover:text-maslow-gold transition-colors mb-2 leading-snug">
                  {note.title}
                </h2>
                <p className="text-base text-[color-mix(in_srgb,var(--navy)_70%,transparent)] leading-relaxed">
                  {note.excerpt}
                </p>
                <span className="inline-block mt-3 text-xs uppercase tracking-[0.14em] text-[color-mix(in_srgb,var(--navy)_45%,transparent)] group-hover:text-maslow-gold transition-colors">
                  Read &rarr;
                </span>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FieldNotesIndex;
